<template>
  <div class="sku-params" mg-stat-mod="c_hwpaymoneypop">
    <div class="sku-params__top">
      <span
          :mg-stat-lob="`goods_id=${nowGoodsInfo.goodsId}`"
          mg-stat-click
          mg-stat-custom="cont=关闭&label=pop&direct=cntp&addr=w_sku"
          @click="close"
      >X</span
      >
    </div>
    <div v-show="nowGoodsInfo.goodsId" class="sku-params__header">
      <div class="sku-params__header-img">
        <img :src="nowSkuImg"/>
      </div>
      <div v-if="!isPreSell && !isFlashSale" class="sku-params__header-info">
        <p>{{ nowSkuPrice }}</p>
        <div v-if="isMallVip && nowSkuInfo.memberGoodsPrice" class="mall">
          <span class="vtag">VIP</span>
          <span class="tag">￥</span
          >{{ nowSkuInfo.memberGoodsPrice || data.goods.memberGoodsPrice }}
        </div>
        <div v-if="isMallVip && !nowSkuInfo" class="mall">
          <span class="vtag">VIP</span>
          <span class="tag">￥</span>{{ data.goods.memberGoodsPrice }}
        </div>
        <p>{{ nowSkuTitle }}</p>
        <p>库存：{{ nowSkuStock }}</p>
        <span v-if="data.goods.isBlindBox" style="padding-top: 20px"
        >盲盒商品【不支持退款】</span
        >
      </div>
      <div v-if="isPreSell" class="sku-params__header-info">
        <section>定金 ￥{{ preSellInfo.deposit }}</section>
        <section>预售价 ￥{{ salePrice }}</section>
      </div>
      <div v-if="isFlashSale" class="sku-params__header-info">
        <section>
          秒杀价
          {{
            flashSaleInfo.flashType === 2
                ? `${flashSaleInfo.pointPrice}${this.coinName}`
                : `￥${flashSaleInfo.price}`
          }}
        </section>
        <p>库存：{{ flashSaleInfo.store }}</p>
        <p v-if="flashSaleInfo.buyLimit">限购：{{ flashSaleInfo.buyLimit }}</p>
      </div>
      <div class="sku-params__header-opt">
        <i class="icon minus_bt" @click="subtractNum"></i>
        <div>{{ selectedSkuNum }}</div>
        <i class="icon add_bt" @click="addNum"></i>
      </div>
    </div>
    <div class="sku-params__sku-wrap scroll-touch">
      <section
          v-for="(value, key, index) in allCategory"
          :key="index"
          class="sku-params__sku"
      >
        <h2 class="sku-params__sku-title">{{ key }}</h2>
        <div class="sku-params__sku-item">
          <div
              v-for="(ele, index2) in value"
              :key="index2"
              :class="getClassName(ele)"
              @click="selectSku(value, ele, index2)"
          >
            {{ ele.item }}
          </div>
        </div>
      </section>
    </div>
    <div :class="['sku-params__button', !isAddCart ? 'confirm_button' : '']">
      <button
          v-if="!isPointsGoods && isAddCart"
          :mg-stat-lob="`goods_id=${nowGoodsInfo.goodsId}&goods_num=${selectedSkuNum}&promType=${nowGoodsInfo.promType}&promId=${nowGoodsInfo.promId}&spec_key=${nowSkuInfo.key}`"
          mg-stat-click
          mg-stat-custom="cont=加入购物车&direct=cntp&addr=w_sku"
          @click="submitForm('add')"
      >
        加入购物车
      </button>
      <button
          v-if="!isPointsGoods"
          :mg-stat-custom="`label=btn&cont=${
          isAddCart ? '立即购买' : '确定'
        }&direct=cntp&addr=w_sku`"
          :mg-stat-lob="`goods_id=${nowGoodsInfo.goodsId}&goods_num=${selectedSkuNum}&promType=${nowGoodsInfo.promType}&promId=${nowGoodsInfo.promId}&spec_key=${nowSkuInfo.key}&orderdc=${orderdc}`"
          mg-stat-click
          @click="submitForm('buyNow')"
      >
        {{ isAddCart ? "立即购买" : "确定" }}
      </button>
      <button
          v-if="isPointsGoods"
          :mg-stat-custom="`label=btn&cont=确定&direct=cntp&addr=w_sku`"
          :mg-stat-lob="`goods_id=${nowGoodsInfo.goodsId}&goods_num=${selectedSkuNum}&promType=${nowGoodsInfo.promType}&promId=${nowGoodsInfo.promId}&spec_key=${nowSkuInfo.key}&orderdc=${orderdc}`"
          mg-stat-click
          @click="submitForm('buyNow')"
      >
        确定
      </button>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapMutations } from 'vuex';
import { judgeLogin } from 'utils/user';
import { uploadAddCart } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import * as GoodsApis from 'apis/goods';
import { guid } from 'utils/index';

function initSkuInfo() {
  return {
    itemId: '',
    key: '',
    price: '',
    storeCount: '',
  };
}

export default {
  props: [
    'data',
    'clickType',
    'goodsId',
    'isPreSell',
    'preSellInfo',
    'flashSaleInfo',
    'isPointsGoods',
    'isBlindBoxGoods',
    'vipType',
    'goodsFrom',
    'storeId',
  ],
  data() {
    return {
      selectedSkuNum: 1, // 已选数量
      allCategory: {}, // 所有品类
      nowGoodsInfo: {
        goodsId: '',
      }, // 商品信息
      nowSkuImg: '',
      nowSkuInfo: initSkuInfo(),
      allSkuInfo: [], // 所有的sku
      isMultiple: false,
      selectedSkuItem: [],
      salePrice: 0,
      isFlashSale: false,
      orderdc: this.guid(),
    };
  },
  computed: {
    isAddCart() {
      return !this.clickType || this.clickType === 'addCart';
    },
    nowSkuPrice() {
      const {
        nowGoodsInfo: { shopPrice, exchangeIntegral, exchangePrice },
        nowSkuInfo: { price, memberGoodsPrice, itemId: selectSkuItemId },
        flashSaleInfo: { price: flashPrice, pointPrice, itemId: flashItemId },
      } = this;
      let showPrice = 0;
      // 选了sku就显示sku的价格 否则显示商品价
      if (this.isFlashActiviing) {
        if (_.isEmpty(this.allSkuInfo)) {
          this.changeIsFlashSale();
        }
        showPrice = memberGoodsPrice || price || shopPrice;
      } else {
        showPrice = price || shopPrice;
      }
      // 秒杀积分价格显示
      if (pointPrice && selectSkuItemId === flashItemId) {
        if (Number(flashPrice)) {
          return `¥${flashPrice}+${pointPrice}${this.coinName}`;
        }
        return `${pointPrice}${this.coinName}`;
      }
      // 积分商品显示价格
      if (exchangeIntegral) {
        if (Number(exchangePrice)) {
          return `¥${exchangePrice}+${exchangeIntegral}${this.coinName}`;
        }
        return `${exchangeIntegral}${this.coinName}`;
      }
      return `￥${showPrice}`;
    },
    isMallVip() {
      return (
        this.data &&
          this.data.goods &&
          this.data.goods.promType === 3 &&
          this.data.goods.memberGoodsPrice
      );
    },
    isFlashActiviing() {
      const { flashSaleInfo } = this;
      const current = new Date().getTime();
      if (
        !_.isEmpty(flashSaleInfo) &&
          flashSaleInfo.store > 0 &&
          flashSaleInfo.startTime < current &&
          current < flashSaleInfo.endTime
      ) {
        return true;
      }
      return false;
    },
    nowSkuTitle() {
      const { selectedSkuItem: items } = this;
      if (Array.isArray(items) && items.length) {
        return `已选：${items.map(f => f.item).join('、')}`;
      }
      return '';
    },
    nowSkuStock() {
      const {
        nowGoodsInfo: { storeCount: allCount },
        nowSkuInfo: { itemId, storeCount },
      } = this;
      if (!itemId) {
        // 没选sku的时候显示总库存
        return allCount;
      }
      return storeCount;
    },
  },
  watch: {
    data: {
      handler(val) {
        if (!_.isEmpty(val)) {
          this.initGoodsInfo(val);
        }
      },
      immediate: true,
    },
    goodsId: {
      // 部分情况需要用到
      handler(id) {
        if (id) {
          this.fetchGoodsDetail(id);
        }
      },
      immediate: true,
    },
    allCategory: {
      handler(val) {
        const ids = [];
        const items = [];
        Object.keys(val).forEach((cat) => {
          val[cat].forEach((f) => {
            if (f.isSelect) {
              ids.push(f.itemId);
              f.categoryName = cat;
              items.push(f);
              if (f.src) {
                this.nowSkuImg = f.src;
              }
            }
          });
        });
        this.selectedSkuItem = items;
        /*
          比如有颜色（1,2,3）、尺码（4,5,6） 括号内的是id
          先点击颜色1 再点击尺码4 和 先点击尺码4 再点击绿色1  join的时候会生成1_4 和 4_1
          但是服务端返回的specGoodsPrice的key值 只有1_4这一种情况  ids应该先从小到大排一次再join
        */
        const skuKey = ids.sort((a, b) => a - b).join('_');
        const skuItem =
            this.allSkuInfo && this.allSkuInfo.length
              ? this.allSkuInfo.find(v => v.key === skuKey)
              : null;
        if (!_.isEmpty(skuItem)) {
          this.nowSkuInfo = skuItem;
          if (
            this.isFlashActiviing &&
              this.flashSaleInfo.itemId === skuItem.itemId
          ) {
            this.isFlashSale = true;
          } else {
            this.isFlashSale = false;
          }
        } else {
          this.nowSkuInfo = initSkuInfo();
        }
        this.getSalePrice();
      },
      immediate: true,
      deep: true,
    },
    selectedSkuNum: {
      handler(val) {
        if (val) {
          this.$emit('chang_num', val);
        }
      },
      immediate: true,
    },
    preSellInfo(val) {
      if (!_.isEmpty(val)) {
        this.salePrice = val.salePrice;
        this.defaultPrePrice = val.salePrice;
      }
    },
  },
  mounted() {
    const height = document.body.clientHeight;
    const ele = document.getElementsByClassName('sku-params__sku-wrap');
    if (height < 414) {
      ele[0].style.maxHeight = `${(height - 180) / 2}px`;
    } else if (height >= 414 && height < 500) {
      ele[0].style.maxHeight = `${(height - 200) / 2}px`;
    } else {
      ele[0].style.maxHeight = `${height * 0.36}px`;
    }
  },
  methods: {
    guid,
    judgeLogin,
    ...mapActions('goods', ['fetchAddCart']),
    ...mapMutations('pay', ['changeBuyNowInfo']),
    async fetchGoodsDetail(id) {
      try {
        const data = await GoodsApis.getGoodsDetail({ id });
        this.initGoodsInfo(data);
      } catch (error) {
        this.$toast('获取商品详情失败');
      }
    },
    initGoodsInfo(val) {
      if (!_.isEmpty(val)) {
        const { goods, specGoodsPrice, filterSpec } = val;
        if (!_.isEmpty(goods)) {
          this.nowGoodsInfo = goods;
          this.nowSkuImg = goods.originalImg;
        }
        if (!_.isEmpty(specGoodsPrice)) {
          this.allSkuInfo = specGoodsPrice;
        }
        if (!_.isEmpty(filterSpec)) {
          this.isMultiple = true;
          Object.keys(filterSpec).forEach((key) => {
            filterSpec[key].forEach((f) => {
              f.isDisable = f.disable;
              f.isSelect = false; // 默认未选中状态
            });
          });
          this.allCategory = _.cloneDeep(filterSpec);
        } else {
          this.isMultiple = false;
        }
      }
    },
    getSalePrice() {
      const {
        isMultiple,
        nowSkuInfo: { salePrice, memberGoodsPrice },
        defaultPrePrice,
      } = this;
      if (isMultiple) {
        if (
          this.flashSaleInfo &&
            this.nowSkuInfo &&
            this.nowSkuInfo.itemId === this.flashSaleInfo.itemId
        ) {
          this.salePrice = memberGoodsPrice;
        } else {
          this.salePrice = salePrice || defaultPrePrice;
        }
      }
    },
    judgeIsDisable() {
      const { allSkuInfo, allCategory, filterId } = this;
      const list = Object.keys(allCategory);
      list.forEach((cat) => {
        allCategory[cat].forEach((sku) => {
          if (!sku.disable) {
            // disable字段为服务端下发的 若为1 表示改品类不能选 所以一直为禁用  其他的需要选择再判断的在类型切换的时候需要初始化一次 值为false
            sku.isDisable = false;
          }
          // 过滤掉与自己同品类的id 这点很重要
          const selectedSkuIds = filterId(cat);
          if (selectedSkuIds.length && allSkuInfo.length) {
            allSkuInfo.forEach((v) => {
              const nowKey = v.key.split('_').map(f => f);
              const concatArr = selectedSkuIds.concat([sku.itemId]);
              /* 判断specGoodsPrice(即所有sku组合)的key 和 当前的sku与选中的sku（已经过滤同品类的id）拼接好的key 是不是一致 */
              if (concatArr.length === nowKey.length) {
                // 首先长度要一致
                const isSameKey = !_.difference(nowKey, concatArr).length; // 再比较两个数组是否一致 如果为长度为0 则一致
                if (isSameKey && Number(v.storeCount) === 0) {
                  /* 如果拼接一样 且库存为0 则置灰显示 */
                  sku.isDisable = true;
                }
              }
            });
          }
        });
      });
    },
    /* 过滤掉与自己同品类的id 改方法不能随意删除 */
    filterId(cat) {
      const { selectedSkuItem } = this;
      const arr = [];
      selectedSkuItem
        .filter(f => f.categoryName !== cat)
        .forEach((g) => {
          arr.push(g.itemId);
        });
      return arr;
    },
    getClassName(val) {
      if (val.isDisable) {
        return 'sku-params__sku-item-disable';
      } else if (val.isSelect) {
        return 'sku-params__sku-item-selected';
      }
      return 'sku-params__sku-item-init';
    },
    subtractNum() {
      const { selectedSkuNum } = this;
      if (selectedSkuNum === 1) {
        return;
      }
      this.selectedSkuNum -= 1;
    },
    addNum() {
      const { selectedSkuNum, nowSkuStock } = this;
      if (selectedSkuNum >= nowSkuStock) {
        this.$toast({
          message: '库存不足',
          iconClass: 'icon toast_warning',
          duration: 1000,
        });
        return;
      }
      this.selectedSkuNum += 1;
    },
    // 选择当前sku
    selectSku(data, ele, index2) {
      if (ele.isDisable) {
        return;
      }
      data.forEach((ele, index) => {
        if (index === index2) {
          /* 为啥不在这里push已选的数据呢 参考上面注释 */
          ele.isSelect = !ele.isSelect;
        } else {
          ele.isSelect = false;
        }
      });
      setTimeout(() => {
        this.judgeIsDisable();
      }, 300);
    },
    async submitForm(type) {
      console.log(this.goodsFrom);
      const temp_orderdc = this.orderdc;
      this.orderdc = this.guid(); // 每次提交都会改变dc
      const {
        nowSkuInfo: { itemId },
        isMultiple,
        selectedSkuNum,
        nowSkuStock,
      } = this;
      // 选择规格
      if (isMultiple && !itemId) {
        this.$toast({
          message: '请选择规格',
          iconClass: 'icon toast_warning',
          duration: 1000,
        });
        return;
      }
      // 库存不足
      if (selectedSkuNum > nowSkuStock) {
        this.$toast({
          message: '库存不足',
          iconClass: 'icon toast_warning',
          duration: 1000,
        });
        return;
      }
      if (type === 'buyNow') {
        // 立即购买
        this.buyNow(isMultiple, temp_orderdc);
      } else {
        // 添加购物车
        this.addCart(isMultiple);
      }
    },
    // 立即购买
    async buyNow(isMultiple, orderdc) {
      this.changeBuyNowInfo(null);
      // 组装通用信息
      const data = {
        action: 'buy_now',
        goodsId: this.nowGoodsInfo.goodsId,
        goodsNum: this.selectedSkuNum,
        isBlindBoxGoods: this.isBlindBoxGoods || false,
        storeId: this.storeId,
      };
      // 预售购买信息组装
      if (this.isPreSell) {
        const {
          preSellInfo,
          preSellInfo: { actId },
        } = this;
        data.actId = actId;
        data.preSellInfo = preSellInfo;
      }
      // 规格购买
      if (isMultiple) {
        data.itemId = this.nowSkuInfo.itemId;
        if (this.isPreSell) {
          data.actId = this.nowSkuInfo.actId;
        }
      }
      // vuex缓存
      this.changeBuyNowInfo(data);
      // 先判断是否登录
      this.judgeLogin(async () => {
        try {
          await GoodsApis.checkGoodsStock(data); /* 校验库存 */
          this.$router.push({ path: '/pay', query: { orderdc } });
        } catch (error) {
          this.$toast(`${error.message}`);
        }
      });
    },
    addCart(isMultiple) {
      const {
        selectedSkuNum,
        nowGoodsInfo: { goodsId },
        nowSkuInfo: { itemId, key },
      } = this;
      const data = {
        goodsId,
        goodsNum: selectedSkuNum,
      };
      if (isMultiple) {
        data.itemId = itemId;
      }
      const val = DataStorage.getFixedUploadParams();
      if (val) {
        data.fromOrigin = val.from || '';
      } else {
        data.fromOrigin = '';
      }

      const specKey = key ? key.replace(/_/g, '-') : 0;
      const gsize_num = `${goodsId}_${specKey}_${selectedSkuNum}`;
      uploadAddCart({ gid: goodsId, gsize_num });
      this.close();
      this.fetchAddCart(data);
    },
    close() {
      this.$emit('close');
    },
    changeIsFlashSale() {
      this.isFlashSale = true;
    },
  },
};
</script>

<style lang="scss">
@import "~assets/css/common.scss";

.sku-params {
  height: 100%;

  &__top {
    height: 60px;
    line-height: 60px;
    padding: 0 33px;
    text-align: right;
    color: #b4b4b4;
    font-size: 33px;
    border-bottom: 2px solid rgba(211, 211, 211, 0.5);
  }

  &__header {
    display: flex;
    padding: 23px 30px 0 30px;

    &-img {
      width: 170px;
      height: 170px;
      margin-right: 30px;

      img {
        max-width: 100%;
        height: 100%;
      }
    }

    &-info {
      flex: 1;
      font-size: 26px;
      padding-right: 20px;

      section {
        font-size: 28px;

        &:nth-of-type(1) {
          font-size: 32px;
          color: #ff4c00;
          font-weight: bold;
          margin: 20px 0 26px 0;
        }
      }

      div.mall {
        margin-left: 15px;
        display: inline-block;
        font-size: 22px;
        text-decoration: none;
        color: rgba(40, 35, 35, 1);
        background: url("../../../assets/img/member/member_success_goods_tag.png") no-repeat rgb(253, 239, 225);
        background-size: 100% 100%;
        padding: 2px 5px;
        border-radius: 5px;
        font-size: 22px;
        height: 32px;
        line-height: 33px;

        .vtag {
          font-size: 22px;
          color: #fff;
        }

        .tag {
          font-size: 12px;
          color: rgba(40, 35, 35, 1);
          margin-left: 0px;
          text-decoration: none;
          border: none;
          margin-left: 6px;
        }
      }

      p {
        color: #9b9b9b;
        margin: 13px 0;
      }

      p:nth-child(1) {
        display: inline;
        font-size: 32px;
        color: #ff4c00;
        vertical-align: middle;
      }

      p:nth-child(2) {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    &-opt {
      width: 133px;
      display: flex;
      align-items: center;
      font-size: 28px;

      div {
        height: 38px;
        text-align: center;
        line-height: 38px;
        width: 57px;
        color: #000000;
      }
    }
  }

  &__sku-wrap {
    overflow-y: scroll;
    padding: 36px 30px;

    section {
      margin-bottom: 36px;
    }

    section:last-child {
      margin-bottom: 0;
    }
  }

  &__sku {
    font-size: 26px;

    &-title {
      height: 37px;
      font-size: 26px;
      color: #9b9b9b;
    }

    &-item {
      display: flex;
      flex-wrap: wrap;

      div {
        padding: 5px 20px;
        margin-right: 40px;
        margin-top: 27px;
        border-radius: 6px;
      }

      &-disable {
        border: 2px solid #d2d2d2;
        color: #9b9b9b;
      }

      &-init {
        border: 2px solid #d2d2d2;
        color: #000;
      }

      &-selected {
        border: 2px solid #ff6002; // 这个border必须一直有 因为border时有时无 会造成宽度实时变化 然后ios的webview会有问题
        color: #ff6002;
        background: #fff;
      }
    }
  }

  &__button {
    display: flex;

    button {
      flex: 1;
      padding: 30px 0;
      text-align: center;
      width: 100%;
      font-size: 30px;
      color: #ff8315;
      background: #fff;
    }

    button:last-child {
      color: #ffffff;
      background: #ff5f00;
    }
  }

  .confirm_button button {
    margin: 0 30px 30px 30px;
    padding: 15px 0;
    border-radius: 12px;
  }
}
</style>
